<template>
  <div class="page applied-config">
    <a-row type="flex" :gutter="10" class="header">
      <a-col flex="10">
        <h1>Управление прикладными настройками</h1>
      </a-col>

      <a-col flex="1">
        <div class="comment">
          Информирование о начале<br />
          годовой выборки
        </div>
      </a-col>

      <a-col flex="1" style="height: 40px">
          <date-picker
            v-if="data.start_formation_reference_sample" style="width: max-content"
            label="Дата"
            :value="data.start_formation_reference_sample"
            format="YYYY-MM-DD"
            class="white-date-picker"
            @input="data.start_formation_reference_sample = $event"
          />
      </a-col>

      <a-col flex="1">
        <a-button type="primary" size="large" @click="save">
          <a-icon type="save" /> Сохранить
        </a-button>
      </a-col>
    </a-row>

    <tabs v-model="activeTab" :tabs="tabTitles" style="margin-top: 10px">
      <div :key="tabs.TAB_DATA_RECEIVING" class="tabs__pane">
        <data-receiving-config v-model="dataReceivingConfig" />
      </div>

      <div :key="tabs.TAB_DATA_STORING" class="tabs__pane">
        <data-storing-config v-model="dataStoringConfig" />
      </div>

      <div :key="tabs.TAB_MACHINE_LEARNING" class="tabs__pane">
        <machine-learning-config v-model="data.machine_learning_config[0].data" />
      </div>

      <div :key="tabs.TAB_MATH_PROCESSING" class="tabs__pane">
        <math-processing v-model="data.math_config[0].data" />
      </div>

      <div :key="tabs.TAB_INTEGRATION" class="tabs__pane">
        <div class="block-wrapper">
          <div class="data-storage-config form">
            <a-row type="flex" align="middle" :gutter="10">
              <a-col flex="2">Возможность подключения иных источников (АПИ)</a-col>
              <a-col flex="3">
                <a-button type="primary" @click="download_doc()">Скачать документацию</a-button>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </tabs>
  </div>
</template>

<script>
import Tabs from '@/components/base/Tabs.vue';
import MathProcessing from '@/pages/applied-config/MathProcessing';
import META_QUERY from '@/queries/meta';
import TABLE_QUERY from '@/queries/table';
import CREATE_MUTATION from '@/queries/mutations/create';
import UPDATE_MUTATION from '@/queries/mutations/update';
import {preparePayload, storage} from '@/helpers';
import MachineLearningConfig from '@/components/machine-learning/MachineLearningConfig';
import DataStoringConfig from '@/pages/applied-config/DataStoringConfig';
import DataReceivingConfig from '@/pages/applied-config/DataReceivingConfig';
import DatePicker from "@/components/base/DatePicker.vue";

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;

const tabs = Object.freeze({
  TAB_DATA_RECEIVING: 'Прием данных',
  TAB_DATA_STORING: 'Хранение данных',
  TAB_MACHINE_LEARNING: 'Машинное обучение',
  TAB_MATH_PROCESSING: 'Математическая обработка',
  TAB_INTEGRATION: 'Интеграция',
});

export default {
  name: 'AppliedConfigPage',
  components: {
    DataReceivingConfig,
    DataStoringConfig,
    MachineLearningConfig,
    MathProcessing,
    Tabs,
    DatePicker
  },

  props: {
    config: {
      type: Object,
      default: null,
    },
  },

  apollo: {
    meta: {
      ...META_QUERY,
      loadingKeys: 'loadingKeys',
      variables() {
        return {
          type: this.type,
        };
      },
      error(error, vm, key, type, { variables }) {
        this.emitError(`Ошибка получения meta-данных ${variables.type}. ${error.message};`);
      },
    },
    sourceData: {
      ...TABLE_QUERY,
      loadingKeys: 'loadingKeys',
      debounce: 250,
      variables() {
        return {
          type: this.type,
          page: 0,
          pageSize: 1,
          filters: [],
          orders: [],
        };
      },
      update({ table }) {
        return table.documents[0] || {};
      },
    },
  },

  data: () => ({
    tabs,
    activeTab: tabs.TAB_DATA_RECEIVING,
    tabTitles: [],
    type: 'FNSAppliedConfig',
    data: {},
    loadingKeys: 0,
  }),

  computed: {
    dataReceivingConfig: {
      get() {
        return this.data;
      },
      set(value) {
        this.data = {
          ...this.data,
          ...value,
        };
      },
    },
    dataStoringConfig: {
      get() {
        return this.data;
      },
      set(value) {
        this.data = {
          ...this.data,
          ...value,
        };
      },
    },
  },

  watch: {
    sourceData: {
      handler() {
        this.initData();
      },
    },
  },

  created() {
    const admin = this.config.sidebar.children.find(
      (el) => el.title === 'Администрирование' || el.title === 'Параметры',
    );
    const apply_customprops = admin
      ? admin.children.find((el) => el.code === 'applied')?.customprops
      : [];
    const visibleTabs = Object.keys(apply_customprops).filter((key) => apply_customprops[key]);
    if (visibleTabs.length) {
      const newTabs = {};
      const newTitles = [];
      visibleTabs.forEach((visTab) => {
        newTabs[visTab] = this.tabs[visTab];
        newTitles.push(this.tabs[visTab]);
      });
      this.tabs = newTabs;
      this.tabTitles = newTitles;
    } else {
      this.tabTitles = Object.values(this.tabs);
    }
    this.activeTab = this.tabTitles[0];
    this.initData();
  },

  methods: {
    changeValue(value, valueName){
      this[valueName] = value
      this.data.start_formation_reference_sample = value
    },
    async download_doc() {
      await this.axios
        .get(`${apiUrl}/download/get_file_from_s3?path=docs/Документация_загрузки_данных_из_альтернативных_источников.docx`, {
          path: 'docs/Документация_загрузки_данных_из_альтернативных_источников.docx'
        }, {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
        .then(({data}) => {
          if (data.status === 0) {
            this.$notification.error({
              message: `Произошла ошибка, файл не найден. Обратитесь к администратору.`,
            });
          } else {
            this.$notification.success({
              message: `Скачиваем файл...`,
            });
            window.location.href = data.fileUrl;
          }
        })
        .catch((error) => {
          console.log(error)
          this.$notification.error({
            message: `Произошла ошибка. Обратитесь к администратору.`,
          });
        })
    },
    initData() {
      const data = this.sourceData?.data || {};

      const math_config = data.math_config || [
        {
          type: 'FNSMathConfig',
          data: {},
        },
      ];

      const machine_learning_config = data.machine_learning_config || [
        {
          type: 'FNSMachineLearningConfig',
          data: {},
        },
      ];

      this.data = data && {
        ...this.data,
        ...data,
        math_config,
        machine_learning_config,
      };
    },
    async save() {
      const response = await this.$apollo.mutate({
        mutation: this.sourceData.id ? UPDATE_MUTATION : CREATE_MUTATION,
        variables: {
          type: this.type,
          id: this.sourceData.id || undefined,
          data: preparePayload(this.data, this.meta.components[this.type].fields),
        },
      });

      const result = response.data.update || response.data.create;

      if (!result.errors.length) {
        this.$notification.success({
          message: 'Данные сохранены',
        });
      } else {
        this.$notification.error({
          message: 'Не удалось сохранить данные',
        });
      }

      return response;
    },
  },
};
</script>

<style lang="scss">
.applied-config {
  .header {
    .comment {
      white-space: nowrap;
      font-size: 12px;
      text-align: right;
    }
  }

  .tabs {
    &__switch-list {
      background: #cdd7e4;
    }

    &__pane {
      padding-top: 20px;
    }
  }

  .form {
    line-height: 17px;

    & > * {
      height: 60px;
    }
  }

  .ant-table-wrapper {
    overflow-x: auto;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 6px;
  }
}
</style>
